import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';
import throttle from 'propel/throttle';

const relatedBentoBlocks = document.querySelectorAll(
	'.block-related-content-bento'
);

if (relatedBentoBlocks.length) {
	const initBlock = (block) => {
		const swiperContainer = block.querySelector('.swiper');
		const slides = block.querySelectorAll('.swiper-slide');
		const loop = slides.length > 2;
		const loopAdditionalSlides = slides.length > 2 ? 1 : 0;
		const settings = {
			loop,
			spaceBetween: 24,
			slidesPerView: 1,
			loopAdditionalSlides,
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			modules: [A11y, Navigation],
			navigation: {
				nextEl: block.querySelector('.swiper-button-next'),
				prevEl: block.querySelector('.swiper-button-prev'),
			},
		};

		let swiperInstance =
			window.innerWidth < 768
				? new Swiper(swiperContainer, settings)
				: null;

		window.addEventListener(
			'resize',
			throttle(() => {
				if (window.innerWidth >= 768 && swiperInstance) {
					swiperInstance.destroy();
					swiperInstance = null;
				} else if (window.innerWidth < 576 && !swiperInstance) {
					swiperInstance = new Swiper(swiperContainer, settings);
				}
			}, 100)
		);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initBlock(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	relatedBentoBlocks.forEach((block) => observer.observe(block));
}
